import React from "react";
import { Link } from "react-router-dom";

const PagesTop = (props) => {
  return (
    <div className="page-top">
      <div
        className="page-title"
        style={{
          background: `url("${props.bg}"), rgba(0, 0, 0, 0.5)`,
          backgroundAttachment: "fixed",
          backgroundSize: "cover",
          backgroundBlendMode: "multiply",
          backgroundRepeat: "no-repeat",
        }}
      >
        <h1>{props.title}</h1>
      </div>
      <div className="page-nav">
        <ul>
          <li>
            <Link to="/">Home</Link>
          </li>
          <p>|</p>
          <li>
            <Link to="#">{props.link}</Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default PagesTop;
